// Each plugin chunk is fetched only when the page actually contains the markup it
// drives. These imports used to be unconditional, so every page — the login screen
// included — downloaded FilePond + heic2any (1.4 MB) and Video.js (0.7 MB) before
// anything could run. The guards mirror what each init() already looks for, so a
// page that has the markup behaves exactly as before.
//
// Video.js is no longer pulled in here at all: _videoJs.js exports an empty init(),
// and its real entry point is initVideoJsWithinVideoModal(), which modules/_modals.js
// now imports on demand when a video modal is actually opened.

import { moduleFailed } from '../utilities/_module_failure.js';

if (document.querySelector('.documents_upload_ctn')) {
    import('./filepond/_documents_upload.js').then(module => module.init()).catch(moduleFailed('_documents_upload.js'));
}

import('./_splide.js').then(module => module.init()).catch(moduleFailed('_splide.js'));
import('./_confetti.js').then(module => module.init()).catch(moduleFailed('_confetti.js'));
